// import { useRef, useEffect } from "react";
import "./input.scss";

const Input = ({
  name,
  type,
  validationRules,
  register,
  errors,
  className,
}) => {
  return (
    <div className="input-container">
      <input
        type={type}
        placeholder="Title"
        className={`form-control ${className}`}
        {...register(name, validationRules)}
      />
      <div className="error-style">{errors[name] && errors[name]?.message}</div>
    </div>
  );
};

export default Input;
